import { IIconProps } from "../types"

export default function IconLL6(props: IIconProps) {
  const width = props.size || props.width || (98 / 5) * 3
  const height = props.size || props.height || (84 / 5) * 3
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 98 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.8042 9.52631C91.0748 6.24736 88.7155 4.18802 85.4966 2.73848C82.2776 1.28895 78.1889 0.449219 74.2102 0.449219C70.2215 0.449219 66.3427 1.28895 62.7039 2.31862C59.075 3.34829 55.6761 4.5679 52.2772 5.21769C48.8883 5.86748 45.4894 5.93746 42.0605 5.59757C38.6316 5.25768 35.1727 4.48792 32.1237 3.79815C29.0747 3.11836 26.4455 2.50856 23.5364 2.65851C20.6274 2.80846 17.4384 3.72817 14.3894 4.94778C11.3403 6.16739 8.43127 7.6969 5.97206 9.67626C3.51285 11.6656 1.50349 14.1048 0.773726 21.8124C0.0539566 29.5199 0.60378 42.4957 1.71342 52.3426C2.82307 62.1894 4.48254 68.8973 6.42192 72.756C8.36129 76.6148 10.5806 77.6045 14.8792 78.5142C19.1678 79.4339 25.5458 80.2736 34.5529 81.1134C43.55 81.9531 55.1963 82.7928 63.3637 82.7928C71.541 82.7928 76.2495 81.9531 79.7484 80.7335C83.2473 79.5139 85.5366 77.9044 87.5459 74.8554C89.5553 71.8063 91.2847 67.2978 93.0541 60.6999C94.8136 54.092 96.613 45.3948 97.2428 38.567C97.8626 31.7392 97.3128 26.7708 96.483 22.0423C95.6433 17.3138 94.5437 12.8053 92.8042 9.52631Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.899712"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
